import script from "./DashboardsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardsView.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardsView.vue?vue&type=style&index=0&id=64f26d8d&lang=css"

const __exports__ = script;

export default __exports__